import * as React from "react";

const ProductAvailabilityInfoIcon: React.FC = () => {
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="2084.000000pt" height="2084.000000pt" viewBox="0 0 2084.000000 2084.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,2084.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M10030 20833 c-774 -33 -1476 -133 -2185 -313 -3140 -797 -5745
-3032 -7020 -6025 -696 -1637 -959 -3453 -759 -5250 324 -2918 1896 -5586
4299 -7301 1455 -1039 3123 -1677 4895 -1874 355 -39 573 -51 1010 -57 694 -9
1219 29 1850 133 2181 359 4175 1397 5730 2980 1509 1537 2495 3477 2844 5594
104 631 142 1156 133 1850 -7 551 -33 891 -108 1400 -377 2570 -1737 4936
-3779 6576 -1866 1499 -4182 2308 -6560 2292 -157 -1 -314 -3 -350 -5z m722
-3158 c356 -62 647 -283 804 -610 150 -312 148 -637 -6 -950 -178 -365 -527
-594 -930 -612 -512 -22 -963 304 -1104 799 -176 614 231 1258 867 1373 99 18
267 18 369 0z m661 -8137 c3 -3665 4 -3910 20 -4011 68 -414 255 -686 573
-834 180 -82 435 -122 844 -132 l275 -6 0 -375 0 -375 -2552 -3 -2553 -2 0
379 0 378 293 6 c527 10 778 65 1008 219 233 155 364 412 399 778 8 81 10
1009 8 3125 -3 2886 -4 3014 -22 3105 -50 257 -163 471 -319 604 -220 187
-503 269 -987 285 l-195 6 -3 365 c-1 201 0 371 3 377 3 10 331 13 1604 13
l1601 0 3 -3902z"/>
</g>
</svg>
    );
};

export default React.memo(ProductAvailabilityInfoIcon);
